$(document).ready(function () {
	// Initialize the search
	let data = [];
	const algolia = algoliasearch(
		'MQ97PLGTN3',
		'e1629e9458dfd6b11bb9bd6fdd4c98a2'
	);

	let userIP = null;
	let intervalId = null;
	if (typeof localStorage !== 'undefined') {
		userIP = localStorage.getItem('userIP');
		if (userIP === null) {
			let counter = 0;
			intervalId = setInterval(() => {
				userIP = localStorage.getItem('userIP');
				counter++;
				if (userIP !== null || counter >= 20) {
					clearInterval(intervalId);
				}
			}, 300);
		}
	}

	function ipToNumber(ip) {
		const parts = ip.split('.');
		return (
			(Number(parts[0]) << 24) +
			(Number(parts[1]) << 16) +
			(Number(parts[2]) << 8) +
			Number(parts[3])
		);
	}

	function isCorstonChineseIp() {
		if (!userIP) return false;
		const numUserIP = ipToNumber(userIP);
		const startIP = ipToNumber('43.230.88.0');
		const endIP = ipToNumber('43.230.91.255');
		return numUserIP >= startIP && numUserIP <= endIP;
	}

	function isUserCorston() {
		switch (userIP) {
			case '195.26.33.20': // UK
				return true;
			case '213.17.239.54': // PL
				return true;
			case '43.230.90.45': // China
				return true;
			default:
				return isCorstonChineseIp() ? true : false;
		}
	}

	aa('init', {
		appId: 'MQ97PLGTN3',
		apiKey: 'e1629e9458dfd6b11bb9bd6fdd4c98a2',
	});

	const index = algolia.initIndex('shopify_products');

	document
		.querySelector('.searchbox')
		.addEventListener('input', async function (event) {
			const query = event.target.value;
			searchInput = event.target;
			if (query.length < 1) return;
			data = await index
				.search(query, {
					clickAnalytics: !isUserCorston(),
				})
				.then(({ queryID, hits }) => {
					return hits.map(hit => {
						return { ...hit, queryID: queryID };
					});
				});
			renderProductResultsNav('desktop');
		});

	$('.mobilesearchbox').on('input', async function (event) {
		const query = event.target.value;
		searchInput = event.target;
		if (query.length < 1) return;
		data = await index
			.search(query, { clickAnalytics: !isUserCorston() })
			.then(({ queryID, hits }) => {
				return hits.map(hit => {
					return { ...hit, queryID: queryID };
				});
			});
		renderProductResultsNav('mobile');
	});

	$('#mainSearchBox').on('input', async function (event) {
		const query = event.target.value;
		searchInput = event.target;
		if (query.length < 1) return;
		data = await index
			.search(query, { clickAnalytics: !isUserCorston() })
			.then(({ queryID, hits }) => {
				return hits.map(hit => {
					return { ...hit, queryID: queryID };
				});
			});
		renderProductResults();
	});

	function renderProductResultsNav(device) {
		$('.view-all-search').show();

		const isMobile = device === 'mobile';
		const appDiv = isMobile
			? $('div#prodsearch-list')[1]
			: $('#prodsearch-list')[0];
		appDiv
			? (appDiv.innerHTML = `
	${
		data && data.length > 0
			? data
					.map((product, i) => {
						if (i > 7) return;
						return product
							? `
				<li class='algolia-product-result-nav search-proditem algolia-prod' 
					prod-queryid='${product.queryID}' 
					prod-pos='${i}' 
					prod-id='${product.objectID}' 
					prod-link='/products/${product.handle}?queryID=${
									product.queryID
							  }'>
					<a>
						<div class='search-prodimg'>
							<img src='${product.image}'/>
						</div>
						<div class='search-prodinfo'>
							<div class='pro-info'>
								<p>
									${product._highlightResult.title.value}
								</p>
								<p>
									${product._highlightResult.sku.value}
								</p>
							</div>
							<div class='prodprice'>
								£${(product.price * 1.2).toFixed(2)}
							</div>
						</div>
					</a>
				</li>
			`
							: '';
					})
					.join('')
			: `<div>No Results for "${
					searchInput?.value || ''
			  }"</div>` // Display "No results" if data array is empty
	}
	`)
			: null;
		// Add analytics for when the user clicks on a product in nav
		$('.algolia-prod').on('click', async function () {
			const objectID = $(this).attr('prod-id');
			const queryID = $(this).attr('prod-queryid');
			try {
				await aa('clickedObjectIDs', {
					index: 'shopify_products',
					queryID: queryID,
					eventName: 'Quick Search: Product Clicked',
					objectIDs: [objectID],
					positions: [Number($(this).attr('prod-pos')) + 1],
				});
			} catch (error) {
				console.log('Error sending view event: ', error);
			}
			window.location.href = $(this).attr('prod-link');
		});
	}

	window.onload = async function () {
		const isSearchPage =
			window.location.pathname.includes('/search');
		if (!isSearchPage) return;
		const urlParams = new URLSearchParams(
			window.location.search
		);
		const query = urlParams.get('q');
		data = await index
			.search(query, { clickAnalytics: !isUserCorston() })
			.then(({ queryID, hits }) => {
				return hits.map(hit => {
					return { ...hit, queryID: queryID };
				});
			});
		renderProductResults();
	};

	function renderProductResults() {
		const appDiv = document.querySelector(
			'.search-results-page.product-listings'
		);
		appDiv
			? (appDiv.innerHTML = `
      ${
				data && data.length > 0
					? data
							.map((product, i) => {
								return product
									? `
                <div class='product-box one-fourth'>
									<div class='prodcolimg'>
										<a class='algolia-prod'
											prod-id='${product.objectID}'
											prod-queryid='${product.queryID}'
											prod-pos='${i}'
											prod-link='/products/${product.handle}?queryID=${
											product.queryID
									  }' 
											href='#'>
											<div style='position: relative; padding-bottom: 100%'>
												<img style='position: absolute; height: 100%; width: 100%;' src='${
													product.image
												}' alt='${product.title}' />
											</div>
										</a>
										<div class='text'>
											<div class="left-col text-col">
												<h3 class="product-name highlight">${
													product._highlightResult.title
														.value
												}</h3>
												<p class="price mobile-hide" translate="no">${formatCurrency(
													product.price * theme.vat_rate
												)}</p>
											</div>
											<div class="rigth-col text-col">
												<p class="product-sku highlight">${
													product._highlightResult.sku.value
												}</p>
												<p class="price desktop-hide" translate="no">${formatCurrency(
													product.price * theme.vat_rate
												)}</p>
												<div class="options">
													<p class="purchasing-btn quickbuy algolia-prod-buy" 
														prod-id='${product.objectID}' 
														prod-queryid='${product.queryID}' 
														prod-price='${product.price * 100}'
														data-handle='${product.handle}'>
														<span>Add to Basket</span>
													</p>
												</div>
											</div>
										</div>
									</div>
                </div>
              `
									: '';
							})
							.join('')
					: `<div>No Results for "${
							searchInput?.value || ''
					  }"</div>` // Display "No results" if data array is empty
			}
      `)
			: null;

		$('.algolia-prod').on('click', async function () {
			const objectID = $(this).attr('prod-id');
			const queryID = $(this).attr('prod-queryid');
			try {
				await aa('clickedObjectIDs', {
					index: 'shopify_products',
					queryID: queryID,
					eventName: 'Search: Product Clicked',
					objectIDs: [objectID],
					positions: [Number($(this).attr('prod-pos')) + 1],
				});
			} catch (error) {
				console.log('error', error);
			}
			window.location.href = $(this).attr('prod-link');
		});

		$('.algolia-prod-buy').on('click', function () {
			if ($(this).attr('disabled')) {
				console.log('disabled');
			} else {
				const objectID = $(this).attr('prod-id'); //variant_id
				const queryID = $(this).attr('prod-queryid');
				let price = $(this).attr('prod-price');
				const prodhandle = $(this).attr('data-handle');

				$('#cart-added .modal-load').html('');

				$.ajax({
					url: '/products/' + prodhandle + '?view=cart',
					type: 'get',
					success: function (response) {
						$('#cart-added .modal-load').html(response);
						$('#cart-added').show();
						$('body').css('overflow', 'hidden');

						var cartItems = CartJS.cart.items;
						var newQty = 0;

						for (item in cartItems) {
							if (cartItems[item].variant_id == objectID) {
								newQty = cartItems[item].quantity;
							}
						}

						CartJS.addItem(objectID, 1);
						newQty = newQty + 1;
						price = formatCurrency(
							(price * newQty * theme.vat_rate) / 100
						);

						$(
							'#cart-added .added-product #product-quantity-top'
						).val(newQty);
						$('#cart-added .added-product .price').text(
							price
						);
						$('.item-backbox #product-quantity-top').attr(
							'placeholder',
							newQty
						);

						document
							.querySelectorAll('.modaladdtocart')
							.forEach(item => {
								item.addEventListener(
									'click',
									modalAddToCart
								);
							});
						document
							.querySelectorAll('.remove-btn span')
							.forEach(item => {
								item.addEventListener(
									'click',
									modalClearItem
								);
							});
					},
				});

				try {
					aa('addedToCartObjectIDsAfterSearch', {
						eventName: 'Search: Product Added to Cart',
						index: 'shopify_products',
						objectIDs: [objectID],
						objectData: [
							{
								queryID: queryID,
								price: price,
								quantity: 1,
							},
						],
						currency: 'GBP',
					});
				} catch (error) {
					console.log('error', error);
				}
			}
		});
	}
});
